import React, { useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";
import FooterContact from './FooterContact';
import FooterInfo from './FooterInfo';

const Footer = ({ context }) => {
	
	const ctxGlobal 		= () => context.global;
	const global 			= ctxGlobal();
	
	const ctxPosts 			= () => context.posts;
	const posts 			= ctxPosts();
	const post 				= posts[0];
        			
    if (global && post) {
							
		if (global.json === null) {
			context.getGlobal(window.location.origin + '/wp-json/virgon/v1/global');
		}
	  		  	
	  	if (global.json !== null) {  
		  	
		  	let footerClass = 'c-footer';
	    	
			return (
				<>
			    	<div className="c-footer">
			    		{post.footer_style === 'full' &&
							<FooterContact block={global.json} />
						}
						<FooterInfo block={global.json} post={post} />
					</div>
				</>
			)
		
		} else {
			
			return null;
			
		}
		
	} else {
		
		return null;
		
	}
		
}
export default WithConsumer(Footer);